import React from "react";
import ManagersOverrideToastContext from "../../context/managersOverrideToastContext";

const WithManagersOverride = Component => {
  return class extends React.Component {
    render() {
      return (
        <ManagersOverrideToastContext.Consumer>
          {toastManagerContext => (
            <Component toastManager={toastManagerContext} {...this.props} />
          )}
        </ManagersOverrideToastContext.Consumer>
      );
    }
  };
};

export default WithManagersOverride;
